
let parser = new DOMParser();

export default function parseXML(xmlString) {
  return parser.parseFromString(xmlString, "application/xml");
}